/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Risk level
 * @export
 * @enum {string}
 */
export enum InternalApiFinalRiskLevel {
    LOW = 'LOW',
    LOW_TO_MEDIUM = 'LOW_TO_MEDIUM',
    MEDIUM = 'MEDIUM',
    MEDIUM_TO_HIGH = 'MEDIUM_TO_HIGH',
    HIGH = 'HIGH',
    UNACCEPTABLE = 'UNACCEPTABLE'
}


export function instanceOfInternalApiFinalRiskLevel(value: any): boolean {
    for (const key in InternalApiFinalRiskLevel) {
        if (Object.prototype.hasOwnProperty.call(InternalApiFinalRiskLevel, key)) {
            if (InternalApiFinalRiskLevel[key as keyof typeof InternalApiFinalRiskLevel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiFinalRiskLevelFromJSON(json: any): InternalApiFinalRiskLevel {
    return InternalApiFinalRiskLevelFromJSONTyped(json, false);
}

export function InternalApiFinalRiskLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskLevel {
    return json as InternalApiFinalRiskLevel;
}

export function InternalApiFinalRiskLevelToJSON(value?: InternalApiFinalRiskLevel | null): any {
    return value as any;
}

export function InternalApiFinalRiskLevelToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiFinalRiskLevel {
    return value as InternalApiFinalRiskLevel;
}

